import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { OneTimePaymentRequest, OneTimePaymentResponse } from "src/app/models";
import { PrintPaymentReceiptComponent } from "../payment-submitted-dialog/print-payment-receipt/print-payment-receipt.component";
import { PrintChaseReceiptComponent } from "./print-chase-receipt/print-chase-receipt.component";

@Component({
    selector: "app-chase-success-dialog",
    templateUrl: "./chase-success-dialog.component.html",
    styleUrls: ["./chase-success-dialog.component.scss"],
})
export class ChaseSuccessDialogComponent implements OnInit
{

    public refNo: string;

    constructor(
        public dialogRef: MatDialogRef<ChaseSuccessDialogComponent>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: { otpResponse: any, paymentInfo: OneTimePaymentRequest },
    ) { }

    ngOnInit(): void
    {
        this.refNo = this.getRefNo();
    }

    public getRefNo(): string
    {
        return this.data.otpResponse.ReferenceNumber;
    }

    public handleDoneClick(): void
    {
        this.dialogRef.close();
    }

    public printReceipt()
    {

        //this.dialogRef.close();

        const dialogRef = this.dialog.open(PrintChaseReceiptComponent, {
            minWidth: 400,
            maxWidth: "600px",
            minHeight: "600px",
            disableClose: true,
        });
        const instance = dialogRef.componentInstance;
        instance.otpResponse = this.data.otpResponse;
        instance.paymentInfo = this.data.paymentInfo;

        dialogRef.afterClosed().subscribe(_ =>
        {
            this.dialog.closeAll();
        });

    }
}

